import { useCallback } from 'react';

import { useMutation } from '@apollo/client/react';
import log from 'loglevel';

import { useToast } from '@admin-platform/ui/components';

import { parseGraphQLErrorForUser } from '../utils/normalizeGraphqlError';

import CLEAR_CACHE_MUTATION from './mutations/clearCache.mutation.graphql';
import type {
  ClearCacheMutation,
  ClearCacheMutationVariables,
} from './mutations/clearCache.mutation.graphql';

/**
 * Hook that provides a function to clear the backend pricing cache
 * Useful for clearing server-side cached data
 */
export function useClearBackendCache(): () => Promise<void> {
  const toast = useToast();
  const [clearPricingCache] = useMutation<
    ClearCacheMutation,
    ClearCacheMutationVariables
  >(CLEAR_CACHE_MUTATION);

  return useCallback(async () => {
    try {
      await clearPricingCache();
    } catch (error) {
      const userFriendlyMessage = parseGraphQLErrorForUser(error);
      toast(userFriendlyMessage, 'error');
      log.error('Failed to clear backend cache:', error);
    }
  }, [clearPricingCache, toast]);
}
